export enum SapEtaScenarioEnum {
  SC3 = 'SC3',
  SC4 = 'SC4',
  SC3SAPMapping = 'SC3_SAP_MAPPING',
  SC4SAPMapping = 'SC4_SAP_MAPPING',
}
